import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";

const CardsContent = ({data}) => {

    useEffect(() => {
        const summaryLabels = [
            "Total de atendimentos",
            "Agendado",
            "Não agendado"
        ];

        const summaryValues = [
            data.attendanceCards?.[0]?.total,
            data.attendanceCards?.[0]?.with_schedule,
            data.attendanceCards?.[0]?.without_schedule
        ];

        ReportUtils.createExportableTable(summaryLabels, summaryValues, "Cards");
    }, [data]);

    return (
        <>
            <div className="grid grid-cols-3 gap-2">
                <div className="text-center">
                    <div className="box boxCount">
                        <h3>Total de atendimentos</h3><h2>{data.attendanceCards?.[0]?.total ?? '0'}</h2>
                    </div>
                </div>

                <div className="text-center">
                    <div className="box boxCount">
                        <h3>Agendado</h3><h2>{data.attendanceCards?.[0]?.with_schedule ?? '0'}</h2>
                    </div>
                </div>

                <div className="text-center">
                    <div className="box boxCount">
                        <h3>Não agendado</h3><h2>{data.attendanceCards?.[0]?.without_schedule ?? '0'}</h2>
                    </div>
                </div>
            </div>

            <div className="chart-divisor"></div>
        </>
    );
};

export default CardsContent;